import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  withStyles,
  Typography,
  ListItem,
  ListItemSecondaryAction,
  Avatar,
  Checkbox,
  FormControl,
  OutlinedInput,
  Select,
  MenuItem,
  InputAdornment,
  ListSubheader,
  Divider,
  ListItemIcon,
  Hidden,
} from '@material-ui/core'
import PersonIcon from '@material-ui/icons/Person'
import classNames from 'classnames'
import { deleteContact, getContact } from 'actions/contacts'
import { selectContact } from 'actions/contacts/addOrEdit'
import {
  addContactsToGroup,
  removeContactsFromGroup,
} from 'actions/contacts/groups'
import MoreMenu from './MoreMenu'
import AvatarWithLabel from 'components/Inbox/AvatarWithLabel'
import { updateContactWithUser } from 'actions/roundRobin'
import { detail } from './index'
import styles from './styles'
import { create } from 'actions/data'
import { AccountConvert } from 'mdi-material-ui'
import { openSnackbar } from 'actions/view'

export const displayName = contact => {
  return contact?.first_name || contact?.middle_name || contact?.last_name
    ? `${contact?.first_name ? `${contact?.first_name} ` : ''}${
        contact?.middle_name ? `${contact?.middle_name} ` : ''
      }${contact?.last_name ? `${contact?.last_name} ` : ''}`
    : detail(contact)
}

export default connect(
  (state, { contact }) => ({
    selected: Boolean(state.contacts.selectedContacts?.[contact?.id]),
    // assigningIndividualContacts: state.sort?.userAssignment === 'contact/a2',
    currentUser: state?.auth?.session?.idToken?.payload?.['cognito:username'],
    users: state.data?.['account/user'] || {},
    update_contacts:
      state.data?.['account/preference']?.preferences?.update_contacts,
    vr_role: state.auth?.session?.idToken?.payload?.['custom:vr_role'],
    vastuser: state.contacts.contactsWithEmailsByID?.[contact?.id]?.vastuser,
    enabled: state.data?.['account/ap/status']?.enabled,
    assignmentPools: state.data?.['account/ap'],
  }),
  dispatch =>
    bindActionCreators(
      {
        deleteContact,
        addContactsToGroup,
        removeContactsFromGroup,
        selectContact,
        getContact,
        updateContactWithUser,
        create,
        openSnackbar,
      },
      dispatch,
    ),
)(
  withStyles(styles)(
    class PanelComponent extends Component {
      state = {
        value: 'user_unassigned',
      }

      componentDidUpdate(prevProps) {
        if (
          this.props.assigningIndividualContacts &&
          prevProps.assigningIndividualContacts !==
            this.props.assigningIndividualContacts
        ) {
          this.setState({ value: 'user_unassigned' })
        }
      }

      render() {
        const {
          classes,
          contact,
          selected,
          addOrEditPush,
          selectContact,
          // assigningIndividualContacts,
          users,
          currentUser,
          enabled,
          vastuser,
          update_contacts,
          vr_role,
          isPinned,
        } = this.props

        const detailText =
          contact?.first_name || contact?.middle_name || contact?.last_name
            ? detail(contact)
            : ''

        const hasUpdatePermissions =
          update_contacts === 'anybody' ||
          (update_contacts === 'accountowner' && vr_role === 'acctowner') ||
          (update_contacts === 'contactowner' &&
            (currentUser === vastuser || vr_role === 'acctowner'))

        const label = user =>
          user?.user_name === currentUser
            ? 'Me'
            : `${user?.first_name || ''} ${user?.last_name || ''}`

        const avatarLabel = user => `${user?.first_name} ${user?.last_name}`

        const assignedUser = vastuser ? (
          <span className={classes.avatar}>
            <div style={{ position: 'relative' }}>
              <Hidden mdUp>
                <div style={{ textAlign: 'center', width: 10 }}>
                  <Avatar
                    style={{
                      backgroundColor: '#014c94',
                      width: 10,
                      height: 10,
                    }}
                  />
                </div>
              </Hidden>
              <Hidden smDown>
                <AvatarWithLabel
                  label={
                    enabled
                      ? avatarLabel(users?.[vastuser])
                      : avatarLabel(
                          users?.[contact?.vastuser] || {
                            first_name: 'Not',
                            last_name: 'Applicable',
                          },
                        )
                  }
                  noType
                  type="user"
                />
              </Hidden>
            </div>
            <span className={classes.avatarLabel}>
              <Typography noWrap className={classes.avatarLabelTypography}>
                {label(
                  users?.[vastuser] || {
                    first_name: 'Unassigned',
                  },
                )}
              </Typography>
            </span>
          </span>
        ) : null

        const items = Object.values(users || {}).map(user => ({
          label: label(user),
          value: `user_${user?.user_name}`,
        }))

        const assignmentPools = Object.values(
          this.props.assignmentPools || {},
        ).map(poolObj => ({
          label: poolObj?.name,
          value: `pool_${poolObj?.id}_${poolObj?.name}`,
        }))

        const assignmentDropdown =
          this.state.value !== 'user_unassigned' ? null : (
            <span
              onClick={e => e?.stopPropagation?.()}
              className={classes.select}
            >
              <FormControl fullWidth variant="outlined">
                <Select
                  classes={{ selectMenu: classes.selectMenu }}
                  value={this.state.value}
                  onChange={e => {
                    if (e?.target?.value?.slice?.(0, 5) === 'user_') {
                      this.props
                        .updateContactWithUser(
                          e?.target?.value === 'user_unassigned'
                            ? null
                            : e?.target?.value?.slice?.(5),
                          contact?.id,
                        )
                        .then(() => this.setState({ value: e?.target?.value }))
                    }

                    if (e?.target?.value?.slice?.(0, 5) === 'pool_') {
                      // console.log('pool_')
                      const stringArr = e.target.value.split('_')
                      const isDefault = stringArr[2] === 'default'

                      const entity = isDefault
                        ? {
                            use_default_assignment_pool: true,
                          }
                        : {
                            use_default_assignment_pool: false,
                            assignmentpool_id: parseInt(stringArr[1]),
                          }

                      this.props
                        .create({
                          entity,
                          noReturnValue: true,
                          path: `contact/${contact.id}/assign`,
                          hasSchema: false,
                          snackbarMessage: `Successfully assigned contact via ${stringArr[2]}!`,
                        })
                        .then(() => {
                          this.props.getContact(contact.id).then(payload => {
                            if (payload?.vastuser) {
                              this.setState({
                                value: `user_${payload.vastuser}`,
                              })

                              const user = this.props.users?.[payload.vastuser]

                              const userFullName = user
                                ? user?.user_name === this.props.currentUser
                                  ? 'you'
                                  : `${user?.first_name || ''} ${
                                      user?.last_name || ''
                                    }`
                                : 'unknown'

                              this.props.openSnackbar({
                                type: 'success',
                                message: `This contact is now assigned to ${userFullName}`,
                              })
                            } else {
                              this.setState({ value: 'user_unassigned' })
                              this.props.openSnackbar({
                                type: 'success',
                                message: `Contact is now unassigned`,
                              })
                            }
                          })
                        })
                    }
                  }}
                  input={
                    <OutlinedInput
                      startAdornment={
                        <InputAdornment position="start">
                          <PersonIcon style={{ color: '#014c94' }} />
                        </InputAdornment>
                      }
                      labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
                      id={`formTextFieldUserAssignment`}
                      classes={{
                        notchedOutline: classes.notchedOutline,
                      }}
                    />
                  }
                >
                  <ListSubheader>Assign to a pool:</ListSubheader>
                  {assignmentPools.map(item => (
                    <MenuItem
                      key={`assignmentPoolValue${item.value}`}
                      value={item.value}
                    >
                      <ListItemIcon>
                        <AccountConvert className={classes.icon} />
                      </ListItemIcon>
                      {item.label}
                    </MenuItem>
                  ))}
                  <Divider />
                  <ListSubheader>Assign to:</ListSubheader>
                  <MenuItem value="user_unassigned">Unassigned</MenuItem>
                  {items.map(item => (
                    <MenuItem
                      key={`userAssignmentValue${item.value}`}
                      value={item.value}
                    >
                      <ListItemIcon>
                        <PersonIcon className={classes.icon} />
                      </ListItemIcon>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </span>
          )

        const dates = (
          <div className={classes.dates}>
            <em>
              {contact?.when_created && (
                <span className={classes.dateInfo}>
                  <span>Created: </span>
                  <span className={classes.date}>
                    {new Date(contact?.when_created)?.toLocaleDateString?.()}
                  </span>
                </span>
              )}
              {contact?.when_last_inbound && (
                <span className={classes.dateInfo}>
                  <span>Last inbound message: </span>
                  <span className={classes.date}>
                    {new Date(
                      contact?.when_last_inbound,
                    )?.toLocaleDateString?.()}
                  </span>
                </span>
              )}
              {contact?.when_last_outbound && (
                <span className={classes.dateInfo}>
                  <span>Last outbound message: </span>
                  <span className={classes.date}>
                    {new Date(
                      contact?.when_last_outbound,
                    )?.toLocaleDateString?.()}
                  </span>
                </span>
              )}
              {contact?.when_assigned && (
                <span className={classes.dateInfo}>
                  <span>Assigned: </span>
                  <span className={classes.date}>
                    {new Date(contact?.when_assigned)?.toLocaleDateString?.()}
                  </span>
                </span>
              )}
            </em>
          </div>
        )

        return (
          <ListItem
            className={classNames(classes.panel, 'contact-expansion-panel')}
            button
            onClick={() => addOrEditPush(contact?.id)}
            classes={{ container: classes.container }}
          >
            <div className={classes.panelContentWhenAssigningUsers}>
              <div className={classes.left}>
                <div className={classes.checkboxContainer}>
                  <div className={classes.checkbox}>
                    <Checkbox
                      onClick={e => e.stopPropagation()}
                      checked={selected ? true : false}
                      onChange={e => selectContact(contact, e.target.checked)}
                      className="contact-expansion-panel-checkbox"
                      classes={{
                        root: selected ? null : classes.panelCheckbox,
                      }}
                    />
                  </div>
                </div>
                <Avatar
                  style={selected ? { display: 'none' } : null}
                  className={'contact-expansion-panel-avatar'}
                  classes={{
                    root: classes.avatarRoot,
                    colorDefault: classes.colorDefault,
                  }}
                >
                  {contact?.first_name ||
                  contact?.middle_name ||
                  contact?.last_name ? (
                    `${
                      contact?.first_name
                        ? `${contact?.first_name.slice(0, 1)}`
                        : ''
                    }${
                      contact?.middle_name &&
                      (!contact?.first_name || !contact?.last_name)
                        ? `${contact?.middle_name.slice(0, 1)}`
                        : ''
                    }${
                      contact?.last_name
                        ? `${contact?.last_name.slice(0, 1)}`
                        : ''
                    }`
                  ) : (
                    <PersonIcon />
                  )}
                </Avatar>
              </div>
              <Typography noWrap className={classes.heading}>
                {isPinned ? '📌 ' : ''}
                {displayName(contact)}
              </Typography>
              {enabled && hasUpdatePermissions && !vastuser
                ? assignmentDropdown
                : assignedUser}
              {detailText || contact?.location ? (
                <Typography noWrap className={classes.secondaryHeading}>
                  {detailText}
                  {detailText && contact?.location
                    ? ' | ' + contact?.location
                    : contact?.location || ''}
                </Typography>
              ) : null}
              {enabled && hasUpdatePermissions && !vastuser ? (
                <Hidden smDown>{dates}</Hidden>
              ) : (
                dates
              )}
            </div>
            <ListItemSecondaryAction>
              <MoreMenu addOrEditPush={addOrEditPush} contact={contact} />
            </ListItemSecondaryAction>
          </ListItem>
        )
      }
    },
  ),
)
